export default __webpack_public_path__ + "static/media/pizzas-6.5c1f6343.jpg";